export const statuses = {
  open: 'Aberta',
  appealed: 'Em recurso',
  overturned: 'Acatada',
  partially_overturned: 'Acatada parcial',
  maintained: 'Mantida',
  accepted: 'Aceita',
};

export const icons = {
  open: 'exclamation-circle',
  appealed: 'gavel',
  overturned: 'check-circle',
  partially_overturned: 'adjust',
  maintained: 'times-circle',
  accepted: 'minus-circle',
};

export const hints = {
  accepted: 'Perda assumida',
};

export function getName(value) {
  return statuses[value] || value;
}

export function getIcon(value) {
  return icons[value] || 'circle';
}
